import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { OTPInput } from "../otp/otp";

type Props = {
    email?: string;
    onValidate: (otp: string) => void;
    onResend: () => void;
    onBack: () => void;
};

const RESEND_SECONDS = 42;

const formatClock = (s: number) => `00:${s.toString().padStart(2, '0')}`;

export const VerifyEmail: React.FC<Props> = ({ email, onValidate, onResend, onBack }) => {
    const [otp, setOtp] = useState('')
    const [seconds, setSeconds] = useState(RESEND_SECONDS)

    useEffect(() => {
        if (seconds <= 0) return
        const id = setTimeout(() => setSeconds((s) => s - 1), 1000)
        return () => clearTimeout(id)
    }, [seconds])

    const handleResend = () => {
        if (seconds > 0) return
        onResend()
        setSeconds(RESEND_SECONDS)
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2.5 }}>
            <Typography sx={{ fontSize: '13.5px', color: 'text.secondary', textAlign: 'center', lineHeight: 1.6 }}>
                Enviamos um código de 6 dígitos para
                {email && (
                    <>
                        <br />
                        <Box component="strong" sx={{ color: 'text.primary' }}>{email}</Box>
                    </>
                )}
            </Typography>

            <OTPInput value={otp} onChange={setOtp} />

            <Button
                fullWidth
                size="large"
                onClick={() => onValidate(otp)}
                variant="contained"
                color="primary"
                sx={{ height: 54, fontSize: '15px', fontWeight: 600 }}
            >
                Confirmar
            </Button>

            <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
                Não recebeu?{' '}
                <Box
                    component="span"
                    onClick={handleResend}
                    sx={{
                        color: seconds > 0 ? 'text.disabled' : 'primary.main',
                        fontWeight: 600,
                        cursor: seconds > 0 ? 'default' : 'pointer',
                    }}
                >
                    Reenviar código
                </Box>
                {seconds > 0 && <Box component="span" sx={{ color: 'text.disabled' }}> · {formatClock(seconds)}</Box>}
            </Typography>

            <Button onClick={onBack} variant="text" color="secondary" sx={{ fontWeight: 600 }}>
                Voltar
            </Button>
        </Box>
    )
}
